module.exports = __webpack_public_path__ + "img/20200515_162351.cf92aaeb.jpg";